import { render } from "./Beats.vue?vue&type=template&id=9404e604"
import script from "./Beats.vue?vue&type=script&lang=js"
export * from "./Beats.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Desktop/personal_projects/music_quiz/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__